<template>
	<v-navigation-drawer
		v-if="this.$route.name != 'Login'"
		v-model="drawer"
		app
		width="290"
	>
		<div>
			<v-col>
				<v-list-item-action v-if="!userParams.logoPath">
					<v-img :src="logo" max-width="100" max-height="100"></v-img>
				</v-list-item-action>
				<v-list-item-action v-else>
					<v-img
						:src="userParams.logoPath"
						max-width="100"
						max-height="100"
					></v-img>
				</v-list-item-action>
			</v-col>
		</div>
		<v-card-actions class="pl-1">
			<v-list-item>
				<v-list-item-content>
					<v-list-item-title class="title">
						{{ userParams.username }}
					</v-list-item-title>
					<v-list-item-subtitle
						>V.Server {{ userParams.version }}</v-list-item-subtitle
					>
					<v-list-item-subtitle>V.Client {{ $version }}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
			<v-spacer />

			<locale-select
				class="mt-6"
				v-if="drawer"
				outlined
				compact
			></locale-select>
		</v-card-actions>
		<v-divider></v-divider>

		<v-list dense nav>
			<v-list-item
				v-for="item in menuShow"
				:key="item.title"
				link
				@click="navigate(item)"
			>
				<v-list-item-icon>
					<v-icon>{{ item.icon }}</v-icon>
				</v-list-item-icon>

				<v-list-item-content>
					<v-list-item-title>{{ item.title }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
	export default {
		data() {
			return {
				logo: require("../../assets/simjob.png"),
				drawer: false,
				userParams: {},
				menuShow: [],
				menuss: [
					// {
					//   title: "Kanban",
					//   route: "Kanban",
					//   access: null, //[{ type: "Environment", value: "Show" }],
					//   group: false,
					//   icon: "mdi-chevron-right"
					// },
					{
						title: this.$tc("entities.job.title", 1),
						route: "SolicJobs",
						access: null, //[{ type: "Environment", value: "Show" }],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("analyzeInput.title", 1),
						route: "AnalyzeInputGroup",
						access: null, //[{ type: "Environment", value: "Show" }],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.report.title", 1),
						route: "Reports",
						access: [
							{
								type: "Report",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					// {
					//   title: "Correção de Registros",
					//   route: "RegEdit",
					//   access: [
					//     { type: "Report", value: "Show" },
					//     { type: "Report", value: "Edit" }
					//   ],
					//   group: false,
					//   icon: "mdi-chevron-right"
					// },
					{
						title: this.$tc("entities.action.title", 1),
						route: "Actions",
						access: [
							{
								type: "Action",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.printer.title", 1),
						route: "Printers",
						access: [
							{
								type: "Printer",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.environment.title", 2),
						route: "Environments",
						access: [
							{
								type: "Environment",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.regType.title", 2),
						route: "Reg Types",
						access: [
							{
								type: "RegType",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.account.title", 2),
						route: "Accounts",
						access: [
							{
								type: "Account",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.unit.title", 2),
						route: "Units",
						access: [
							{
								type: "Unit",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.resource.title", 2),
						route: "Resources",
						access: [
							{
								type: "Resource",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.item.title", 2),
						route: "Items",
						access: [
							{
								type: "Item",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.stageType.title", 2),
						route: "Stage Types",
						access: [
							{
								type: "StageType",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.job.title", 2),
						route: "Jobs",
						access: [
							{
								type: "Job",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.user.title", 2),
						route: "Users",
						access: [
							{
								type: "User",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
				],
			};
		},
		computed: {
			menus() {
				return [
					// {
					//   title: "Kanban",
					//   route: "Kanban",
					//   access: null, //[{ type: "Environment", value: "Show" }],
					//   group: false,
					//   icon: "mdi-chevron-right"
					// },
					{
						title: this.$t("entities.job.solic"),
						route: "SolicJobs",
						access: [
							{
								type: "Job",
								value: "Show",
							},
						], //[{ type: "Environment", value: "Show" }],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("analyzeInput.title", 1),
						route: "AnalyzeInputGroup",
						access: null, //[{ type: "Environment", value: "Show" }],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.report.title", 2),
						route: "Reports",
						access: [
							{
								type: "Report",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.printer.title", 1),
						route: "Printers",
						access: [
							{
								type: "Printer",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.environment.title", 2),
						route: "Environments",
						access: [
							{
								type: "Environment",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.regType.title", 2),
						route: "Reg Types",
						access: [
							{
								type: "RegType",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.account.title", 2),
						route: "Accounts",
						access: [
							{
								type: "Account",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.unit.title", 2),
						route: "Units",
						access: [
							{
								type: "Unit",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.action.title", 2),
						route: "Actions",
						access: [
							{
								type: "Action",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.resource.title", 2),
						route: "Resources",
						access: [
							{
								type: "Resource",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.regEdit.title", 2),
						route: "RegSearch",
						access: [
							{
								type: "Reg",
								value: "Show",
							},
							{
								type: "Reg",
								value: "Edit",
							},
							{
								type: "Reg",
								value: "Delete",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.item.title", 2),
						route: "Items",
						access: [
							{
								type: "Item",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.stageType.title", 2),
						route: "Stage Types",
						access: [
							{
								type: "StageType",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.entityFieldCustom.title", 2),
						route: "EntityFieldCustoms",
						access: [
							{
								type: "EntityFieldCustom",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.job.title", 2),
						route: "Jobs",
						access: [
							{
								type: "Job",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
					{
						title: this.$tc("entities.user.title", 2),
						route: "Users",
						access: [
							{
								type: "User",
								value: "Show",
							},
						],
						group: false,
						icon: "mdi-chevron-right",
					},
				].sort((a, b) => {
					if (a.title < b.title) {
						return -1;
					}
					if (a.title > b.title) {
						return 1;
					}
					return 0;
				});
			},
		},
		watch: {
			async drawer(value) {
				if (value == true) {
					await this.getUserParams();
					await this.confirmAccess();
				}
			},
		},
		methods: {
			async confirmAccess() {
				let isAdmin = await this.$auth.isAdmin();
				let claims = await this.$auth.getUserClaims();
				if (isAdmin) {
					this.menuShow = this.menus;
					return;
				}

				let menuAllow = [];
				this.menus.forEach((m) => {
					let menu = this.menuAllowed(m, claims);
					if (menu != null) menuAllow.push(menu);
				});

				this.menuShow = menuAllow;
			},

			claimExist(access, claims) {
				if (!access) return true;
				if (Array.isArray(access)) {
					let allow = false;
					access.forEach((a) => {
						if (this.claimExist(a, claims)) allow = true;
					});

					return allow;
				}

				return (
					claims.filter((c) => c.type == access.type && c.value == access.value)
						.length > 0
				);
			},

			menuAllowed(menu, claims) {
				if (!menu.group)
					return this.claimExist(menu.access, claims) ? menu : null;

				let children = menu.children;
				children.forEach((ch) => {
					if (!this.claimExist(ch.access, claims))
						children.splice(children.indexOf(ch), 1);
				});

				return menu.children.length > 0 ? menu : null;
			},

			isAdmin(claims) {
				return claims.filter((c) => c.type == "Admin").length > 0;
			},
			navigate(item) {
				this.$router.push({
					name: item.route,
				});
				this.openDrawer();
			},
			async getUserParams() {
				let params = await this.$auth.getUserParams();
				if (params) this.userParams = params;
				console.log(this.userParams); // permissão por horário
			},
			openDrawer(open) {
				if (open == null) {
					this.drawer = !this.drawer;
					this.$forceUpdate();
				} else {
					this.drawer = open;
					this.$forceUpdate();
				}
			},
		},
		async mounted() {
			await this.getUserParams();
			await this.confirmAccess();
			this.menuShow.sort((a, b) => {
				if (a.title < b.title) {
					return -1;
				}
				if (a.title > b.title) {
					return 1;
				}
				return 0;
			});
		},
		created() {
			this.$root.$on("openDrawer", (open) => {
				if (open == null) this.openDrawer();
				else this.openDrawer(open);
			});
		},
	};
</script>
